import { inject, Injectable } from '@angular/core';
import { ApiService } from '@features/api';
import { map } from 'rxjs';

export interface Partner {
  name: string;
  image_url: string;
  website_url: string;
}

@Injectable({
  providedIn: 'root',
})
export class PartnersService {
  protected api = inject(ApiService);

  list() {
    return this.api.get<{ data: Partner[] }>('/partners').pipe(map((response) => response.data));
  }
}
